import React, { useEffect, useState } from "react";
import { BadgeCheck } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import api from "@/lib/api";
import { VendorCard } from "@/components/discovery/VendorCard";
import { VERIFICATION_LABELS, breadcrumbLd } from "@/lib/siteContent";

const crumbs = [{ label: "Home", to: "/" }, { label: "Verified Profiles", to: "/verified-profiles" }];

export default function VerifiedProfiles() {
  const [vendors, setVendors] = useState([]);
  useEffect(() => { api.get("/discovery/vendors?limit=12").then((r) => setVendors(r.data.items)).catch(() => {}); }, []);

  return (
    <div className="ca-container py-12">
      <Seo title="Verified Business Profiles | ComplaintAdvisor"
        description="Explore business profiles with clearly explained verification indicators, submitted documents, verification dates, and profile-status information."
        path="/verified-profiles" jsonld={breadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-3 flex items-center gap-2"><BadgeCheck className="h-7 w-7 text-teal" /> Verified Profiles</h1>
      <p className="text-slate-700 mt-3 max-w-2xl">
        Verification indicators explain exactly what has been checked. Verification may relate to business documents,
        contact information, identity information, or another limited attribute. A profile is not described as
        "fully trustworthy", "fraud-free", or "government approved".
      </p>

      <div className="mt-6 grid sm:grid-cols-2 gap-2">
        {VERIFICATION_LABELS.map(([label, desc]) => (
          <div key={label} className="rounded-xl border border-slate-200 bg-white p-3">
            <p className="text-sm font-semibold text-slate-800">{label}</p>
            <p className="text-xs text-slate-500 mt-0.5">{desc}</p>
          </div>
        ))}
      </div>

      <h2 className="font-display text-lg font-bold text-slate-900 mt-10">Profiles</h2>
      <div className="mt-3 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {vendors.map((v) => <VendorCard key={v.slug} v={v} />)}
      </div>
    </div>
  );
}
